/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Gallery_TitleInputs */

const en_meta_showcase_gallery_title = /** @type {(inputs: Meta_Showcase_Gallery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel Photo Gallery for Booking Websites: Demo | Lindevo`)
};

const lv_meta_showcase_gallery_title = /** @type {(inputs: Meta_Showcase_Gallery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viesnīcas foto galerija mājaslapā — demo | Lindevo`)
};

/**
* | output |
* | --- |
* | "Hotel Photo Gallery for Booking Websites: Demo \| Lindevo" |
*
* @param {Meta_Showcase_Gallery_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_gallery_title = /** @type {((inputs?: Meta_Showcase_Gallery_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Gallery_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_gallery_title(inputs)
	return en_meta_showcase_gallery_title(inputs)
});